$.fn.tooltip.Constructor.DEFAULTS.template = '<div class="academia-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';